import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "49",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M0 .5h48v48H0z"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  width: "32",
  height: "26",
  x: "8",
  y: "11.5",
  stroke: "#475467",
  "stroke-width": "2",
  rx: "1"
}, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#475467",
  d: "m40 36.91-7.764-11.662-4.91 7.38-8.243-12.374L8 36.91h32Z"
}, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#475467",
  d: "M29.87 22.292a2.038 2.038 0 1 1-4.077 0c0-1.126.91-2.038 2.038-2.038 1.13 0 2.04.912 2.04 2.038Z"
}, null, -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
export default { render: render }